export enum I18n {
    EN = 'en',
    RO = 'ro',
}
